<template>
  <p class="copyright">© {{ currentYear }} Pitchup.com</p>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Copyright extends Vue {
  get currentYear() {
    const d = new Date()
    return d.getFullYear()
  }
}

export default toNative(Copyright)
</script>
<style scoped>
.copyright {
  color: var(--colour-blue);
  font-size: var(--small);
  text-align: center;
  padding: 0.5em;
  margin: 0;
}
</style>
